// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --organic-arrow-color: #fff;
}
.controls .next,
.controls .prev {
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10%;
  height: 25%;
  position: fixed;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  outline-color: transparent;
  outline-style: none;
  outline-width: 0;
  top: calc(50% - (0.5 * 25%));
}
@media all and (max-width: 520px) {
  .controls .next,
  .controls .prev {
    visibility: hidden;
  }
}
.controls .next .arrowLeft,
.controls .prev .arrowLeft,
.controls .next .arrowRight,
.controls .prev .arrowRight {
  width: 100%;
  height: 40px;
  opacity: 0.5;
  position: relative;
  display: block;
  transition: transform 0.2s ease-out 0.125s, opacity 0.2s ease-out;
}
.controls .next .arrowLeft:before,
.controls .prev .arrowLeft:before,
.controls .next .arrowRight:before,
.controls .prev .arrowRight:before,
.controls .next .arrowLeft:after,
.controls .prev .arrowLeft:after,
.controls .next .arrowRight:after,
.controls .prev .arrowRight:after {
  content: ' ';
  position: absolute;
  border-radius: 0;
  right: calc(50% - (0.7071 * (40px + 4px)) / 2);
  height: 100%;
  width: 4px;
  background-color: var(--organic-arrow-color);
  transition: transform 0.15s ease-out, background-color 0.15s ease-out;
}
.controls .next .arrowLeft:before,
.controls .prev .arrowLeft:before,
.controls .next .arrowRight:before,
.controls .prev .arrowRight:before {
  transform-origin: 100% 100% 0;
  top: -50%;
  transform: rotate(-45deg);
}
.controls .next .arrowLeft:after,
.controls .prev .arrowLeft:after,
.controls .next .arrowRight:after,
.controls .prev .arrowRight:after {
  transform-origin: 100% 0% 0;
  top: 50%;
  transform: rotate(45deg);
}
.controls .next .arrowLeft:before,
.controls .prev .arrowLeft:before,
.controls .next .arrowLeft:after,
.controls .prev .arrowLeft:after {
  right: auto;
  left: calc(50% - (0.7071 * (40px + 4px)) / 2);
}
.controls .next .arrowLeft:before,
.controls .prev .arrowLeft:before {
  transform-origin: 0 100% 0;
  top: -50%;
  transform: rotate(45deg);
}
.controls .next .arrowLeft:after,
.controls .prev .arrowLeft:after {
  transform-origin: 0 0 0;
  top: 50%;
  transform: rotate(-45deg);
}
.controls .next .arrowLeft:hover,
.controls .prev .arrowLeft:hover {
  opacity: 0.9;
}
.controls .next .arrowLeft:hover:before,
.controls .prev .arrowLeft:hover:before {
  transform: rotate(30deg);
}
.controls .next .arrowLeft:hover:after,
.controls .prev .arrowLeft:hover:after {
  transform: rotate(-30deg);
}
.controls .next .arrowRight:hover,
.controls .prev .arrowRight:hover {
  opacity: 0.9;
}
.controls .next .arrowRight:hover:before,
.controls .prev .arrowRight:hover:before {
  transform: rotate(-30deg);
}
.controls .next .arrowRight:hover:after,
.controls .prev .arrowRight:hover:after {
  transform: rotate(30deg);
}
.controls .next {
  right: 0;
}
.controls .next .active {
  transform: translate3d(100%, 0, 0);
}
.controls .next .active:after {
  transform: rotate(90deg) translate3d(50%, 0, 0) !important;
}
.controls .next .active:before {
  transform: rotate(-90deg) translate3d(50%, 0, 0) !important;
}
.controls .prev {
  left: 0;
}
.controls .prev .active {
  transform: translate3d(-100%, 0, 0);
}
.controls .prev .active:after {
  transform: rotate(-90deg) translate3d(-50%, 0, 0) !important;
}
.controls .prev .active:before {
  transform: rotate(90deg) translate3d(-50%, 0, 0) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/CubeSlider/Buttons/Buttons.less"],"names":[],"mappings":"AAWA;EACE,2BAAA;AAVF;AAcA;;EAII,UAAA;EAMA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;AAnBJ;AAGI;EAAA;;IACE,kBAAA;EACJ;AACF;AATA;;;;EAyBM,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,iEAAA;AAVN;AAYM;;;;;;;;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EAGA,YAAA;EACA,UAAA;EACA,4CAAA;EACA,qEAAA;AALR;AAQM;;;;EACE,6BAAA;EACA,SAAA;EACA,yBAAA;AAHR;AAKM;;;;EACE,2BAAA;EACA,QAAA;EACA,wBAAA;AAAR;AAKM;;;;EAEE,WAAA;EACA,6CAAA;AADR;AAIM;;EACE,0BAAA;EACA,SAAA;EACA,wBAAA;AADR;AAGM;;EACE,uBAAA;EACA,QAAA;EACA,yBAAA;AAAR;AAEM;;EACE,YAAA;AACR;AAAQ;;EACE,wBAAA;AAGV;AADQ;;EACE,yBAAA;AAIV;AACM;;EACE,YAAA;AAER;AADQ;;EACE,yBAAA;AAIV;AAFQ;;EACE,wBAAA;AAKV;AAhGA;EAkGI,QAAA;AACJ;AAnGA;EAoGM,kCAAA;AAEN;AADM;EACE,0DAAA;AAGR;AADM;EACE,2DAAA;AAGR;AA5GA;EA+GI,OAAA;AAAJ;AA/GA;EAiHM,mCAAA;AACN;AAAM;EACE,4DAAA;AAER;AAAM;EACE,2DAAA;AAER","sourcesContent":["@control-button-width: 10%;\n@control-button-height: 25%;\n@control-button-opacity: 0.5;\n@control-button-opacity-hover: 0.9;\n@control-button-background: transparent;\n@transition-bezier: cubic-bezier(0.5, 0.075, 0.25, 0.95);\n@organic-arrow-thickness: 4px;\n@organic-arrow-height: 40px;\n@organic-arrow-border-radius: 0;\n@cos45: 0.7071;\n\n:root {\n  --organic-arrow-color: #fff;\n}\n\n\n.controls {\n\n  .next, .prev {\n\n    z-index: 2;\n\n    @media all and (max-width: 520px) {\n      visibility: hidden;\n    }\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: @control-button-width;\n    height: @control-button-height;\n    position: fixed;     \n    background-color: @control-button-background;\n    color: #fff;\n    cursor: pointer;\n    outline-color: transparent;\n    outline-style: none;\n    outline-width: 0;\n    top: calc(50% - (0.5 * @control-button-height));  \n  \n    .arrowLeft, .arrowRight {\n      width: 100%;\n      height: @organic-arrow-height;\n      opacity: @control-button-opacity;\n      position: relative;\n      display: block;\n      transition: transform 0.2s ease-out 0.125s, opacity 0.2s ease-out;\n\n      &:before, &:after { \n        content: ' ';\n        position: absolute;\n        border-radius: @organic-arrow-border-radius;\n        right: calc(\n          50% -\n            (@cos45 * (@organic-arrow-height + @organic-arrow-thickness)) / 2);\n        height: 100%;\n        width: @organic-arrow-thickness;\n        background-color: var(--organic-arrow-color);\n        transition: transform 0.15s ease-out, background-color 0.15s ease-out;\n      }\n\n      &:before {\n        transform-origin: 100% 100% 0;\n        top: -50%;\n        transform: rotate(-45deg);\n      }\n      &:after {\n        transform-origin: 100% 0% 0;\n        top: 50%;\n        transform: rotate(45deg);\n      }\n    }   \n\n    .arrowLeft {\n      &:before,\n      &:after {\n        right: auto;\n        left: calc(\n          50% - (@cos45 * (@organic-arrow-height + @organic-arrow-thickness)) / 2);\n      }\n      &:before {\n        transform-origin: 0 100% 0;\n        top: -50%;\n        transform: rotate(45deg);\n      }\n      &:after {\n        transform-origin: 0 0 0;\n        top: 50%;\n        transform: rotate(-45deg);\n      }\n      &:hover {\n        opacity: @control-button-opacity-hover;\n        &:before {\n          transform: rotate(30deg);\n        }\n        &:after {\n          transform: rotate(-30deg);\n        }\n      }\n    }\n    .arrowRight {\n      &:hover {\n        opacity: @control-button-opacity-hover;\n        &:before {\n          transform: rotate(-30deg);\n        }\n        &:after {\n          transform: rotate(30deg);\n        }\n    }\n    }\n  } \n\n  .next {\n    right: 0;\n    .active {\n      transform: translate3d(100%, 0, 0);\n      &:after {\n        transform: rotate(90deg) translate3d(50%, 0, 0) !important;\n      }\n      &:before {\n        transform: rotate(-90deg) translate3d(50%, 0, 0) !important;\n      }\n    }\n  }\n\n  .prev {\n    left: 0;\n    .active {\n      transform: translate3d(-100%, 0, 0);\n      &:after {\n        transform: rotate(-90deg) translate3d(-50%, 0, 0) !important;\n      }\n      &:before {\n        transform: rotate(90deg) translate3d(-50%, 0, 0) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
